import { ENDPOINT_COTTON_ANALYTICAL, ENDPOINT_PROJECTS_AREA } from '@/common/constants';
import { HttpApi } from '@/common/http';
import { create } from 'zustand';
import { ICottonAnalyticalResponse, ICottonPlan } from '../models/ICottonAnalytical';

interface ICottonAnalyticalStore {
  data: ICottonAnalyticalResponse | null;
  loading: boolean;
  fetchCottonAnalytical: () => Promise<void>;
}

const httpApi = new HttpApi();

export const useCottonAnalyticalStore = create<ICottonAnalyticalStore>(
  (set) => ({
    data: null,
    loading: false,
    fetchCottonAnalytical: async () => {
      set({ loading: true });
      try {
        const [analyticalRes, plansRes] = await Promise.all([
          httpApi.get<ICottonAnalyticalResponse>(ENDPOINT_COTTON_ANALYTICAL, {}),
          httpApi.get<ICottonPlan[]>(ENDPOINT_PROJECTS_AREA, { plant_id: '2', year: '2024' }),
        ]);

        if (analyticalRes) {
          analyticalRes.plans = plansRes || [];
        }

        set({ data: analyticalRes || null });
      } catch (error) {
        console.error('Error fetching cotton analytical data:', error);
        set({ data: null });
      } finally {
        setTimeout(() => {
          set({ loading: false });
        }, 300);
      }
    },
  }),
);
